import React from "react";
import '../../css/promo_swap.css';
import Footer from "../Footer";
import promo17 from '../../assets/images/promociones/swap/banner-swap.webp'

const TERMINOS_URL = "https://www.bajaferries.com.mx/tyc/TyC-Swap-de-barcos.pdf";

const DEFAULT_PROMOS = [
  {
    id: "cabina-50",
    image: "./images/promociones/swap/pasaje.webp",
    imageAlt: "Cabina con descuento del 50% en Baja Ferries",
    title: "Promoción Cabina al 50%",
    description: "Descubre el Cabo Star y obtén 50% de descuento en cabina.",
    validity: "Válido: 5 al 18 de octubre.",
    buttonLabel: "Reserva tu cabina al 50%",
    phone: "8003377437",
  },
  {
    id: "cabina-incluida",
    image: "./images/promociones/swap/cabina.webp",
    imageAlt: "Familia viajando con su auto en Baja Ferries",
    title: "Promoción Cabina incluida",
    description:
      "Viaja con tu auto, familia o amigos e incluye cabina sin costo adicional.",
    validity: "Válido: 5 al 18 de octubre.",
    buttonLabel: "Reserva al · 800 337 74 37",
    phone: "8003377437",
  },
  {
    id: "biker-pod",
    image: "./images/promociones/swap/bikers.webp",
    imageAlt: "Motociclista viajando en la ruta Topolobampo",
    title: "Promoción Biker",
    description: "Viaja en motocicleta y obtén cápsula sin costo adicional.",
    validity: "Válido: 5 al 18 de octubre.",
    buttonLabel: "Reserva tu pod gratis",
    phone: "8003377437",
  },
  {
    id: "ayudante-pod",
    image: "./images/promociones/swap/ayudante.webp",
    imageAlt: "Ayudante de operador de transporte de carga",
    title: "Promoción cápsula para ayudante",
    description: "Cápsula de descanso sin costo adicional para ayudante.",
    validity: "Válido: 5 al 18 de octubre.",
    buttonLabel: "Reserva tu espacio",
    phone: "8003377437",
  },
];

function PromoCard({ promo }) {
  const { image, imageAlt, title, description, validity, buttonLabel, phone } = promo;

  return (
    <article className="promo-card">
      <div className="promo-card__image-wrapper">
        <img className="promo-card__image" src={image} alt={imageAlt} loading="lazy" />
      </div>

      <div className="promo-card__body">
        <h2 className="promo-card__title">{title}</h2>
        <p className="promo-card__lead">{description}</p>

        <div className="promo-card__footer">
          {validity && (
            <p className="promo-card__validity">
              <i className="fi fi-rs-calendar-clock promo-card__validity-icon"></i>
              {validity}
            </p>
          )}

          <a className="promo-card__button" href={`tel:${phone}`}>
            {buttonLabel}
          </a>

          <a
            className="promo-card__terms-link"
            href={TERMINOS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Consulta términos y condiciones
          </a>
        </div>
      </div>
    </article>
  );
}

export default function Promo17({ promos = DEFAULT_PROMOS }) {
  return (
    <>
      <section>
        <div className='header_section'>
          <div className='container header_section_box'>
            <div className='header_section_title'>
              <h3>Promociones para viajar</h3>
              <p>¡Tu próxima aventura te espera!</p>
            </div>
          </div>
        </div>
      </section>

      <section className='container'>
        <div className='banner-header-promo'>
          <img src={promo17} alt='buen-fin-bajaferries' />
        </div>
      </section>

      <section className="promo-section">
        <div className="promo-grid">
          {promos.map((promo) => (
            <PromoCard key={promo.id} promo={promo} />
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}